import { get, getOther, post, put } from './axios.js';
import vuex from '@/store/index';
/**
 * 登录
 */

//登录
export const doLogin = (data) => {
  return post(`/security/web/user/doLogin`, data);
};

// 退出登录
export const logout = (data) => {
  return post(`/security/web/user/exit`, data);
};

//注册
export const register = (data) => {
  return post(`/security/web/user/register`, data);
};

//重置密码-
export const reset = (data) => {
  return post(`/security/web/user/reset`, data);
};

//根据手机号查询用户是否存在
export const getUserInfoByTel = (phone) => {
  let data = {
    phone: phone,
  };

  return get(`/security/web/user/getUserInfoByTel`, data);
};

// 获取验证码----------
export const sendSms = (phone, type) => {
  let data;
  if (type) {
    //注册
    data = {
      phone: phone,
      checkFlag: true,
    };
  } else {
    //非注册
    data = {
      phone: phone,
      checkFlag: false,
    };
  }

  return get(`/security/web/user/sendSms`, data);
};

//验证随机码是否与手机匹配
export const unmatched = (data) => {
  return post(`/security/web/user/unmatched`, data);
};

//获取微信二维码
export const getWxCode = () => {
  return get(`/security/web/wxLogin/getCode`);
};
//微信成功后回调信息
export const wxCallback = (data) => {
  return getOther(`/security/web/wxLogin/callback`, data);
};

//获取qq连接
export const getQqCode = () => {
  return get(`/security/web/qqLogin/getCode`);
};

//QQ成功后回调信息
export const qqCallback = (data) => {
  return getOther(`/security/web/qqLogin/callback`, data);
};

//获取钉钉连接
export const getDdCode = () => {
  return get(`/security/web/cloudClass/eAppLogin/getApplayAuthCodeUrl`);
};

//DD成功后回调信息
export const ddCallback = (data) => {
  return getOther(`/security/web/cloudClass/eAppLogin/callback`, data);
};

//绑定QQ/WX/DD
export const bindingAPP = (data) => {
  return post(`/security/web/user/binding/app`, data);
};

/**
 * 个人信息数据StudentController   security的id使用userIdWrap ```````````````````````````````
 */

//发送邮箱验证码
export const emailCode = (data) => {
  return post(`/security/web/student/emailCode`, data);
};

//重置邮箱
export const resetEmail = (data) => {
  data.set('id', vuex.state.user.userIdWrap);
  return post(`/security/web/student/resetEmail`, data);
};

//重置手机号
export const resetTelephone = (data) => {
  data.set('id', vuex.state.user.userIdWrap);
  return post(`/security/web/student/resetTelephone`, data);
};

//修改个人信息
export const resetUserMsg = (data) => {
  data.set('id', vuex.state.user.userIdWrap);
  return put(`/security/web/student/user`, data);
};

//获取个人信息
export const getUserMsg = (id) => {
  return get(`/security/web/student/selectOne`);
};
